/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Strip trailing .00 from prices
  function stripTrailingZerosFromPrices() {
    function walkTextNodes(node, callback) {
      if (node.nodeType === 3) { // Text node
        callback(node);
      } else {
        for (let child = node.firstChild; child; child = child.nextSibling) {
          walkTextNodes(child, callback);
        }
      }
    }

    // Target common price elements (excluding cart footer which should keep trailing zeros)
    const priceSelectors = [
      '.product__price',
      '.product-price',
      '.product-grid-item__price',
      '.product-upsell__price',
      '.cart__item__price',
      '[data-product-price]',
      '[data-cart-total-price]'
    ];

    priceSelectors.forEach(function(selector) {
      const elements = document.querySelectorAll(selector);
      elements.forEach(function(element) {
        // Skip cart footer totals - they should keep trailing zeros
        if (element.closest('.cart__total--footer') ||
            element.closest('[data-cart-price-holder]') ||
            element.classList.contains('cart__total-prices')) {
          return;
        }

        // Skip add-to-cart button prices - they should keep trailing zeros
        if (element.closest('[data-add-to-cart]') ||
            element.closest('.product__submit__add')) {
          return;
        }

        walkTextNodes(element, function(textNode) {
          let text = textNode.textContent;
          // Strip .00 or .00 followed by space/currency/end
          const originalText = text;
          // Match .00 at end of price, before currency code, or followed by space
          text = text.replace(/\.00(?=\s|$|[A-Z]{3}|,|})/g, '');
          // Also handle formats like $10.00 USD -> $10 USD
          text = text.replace(/(\d)\.00\s+([A-Z]{3})/g, '$1 $2');
          if (text !== originalText) {
            textNode.textContent = text;
          }
        });
      });
    });
  }

  // Run on page load and after dynamic content updates
  function initPriceFormatter() {
    stripTrailingZerosFromPrices();
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initPriceFormatter, 100);
    });
  } else {
    setTimeout(initPriceFormatter, 100);
  }

  // Also run after cart updates and other dynamic content changes
  document.addEventListener('theme:cart:added', function() {
    setTimeout(stripTrailingZerosFromPrices, 200);
  });

  // Ensure cart footer totals update after cart loads/refreshes
  // This is important for selling plan changes where the discount totals need to update
  document.addEventListener('theme:cart:loaded', function() {
    // Format prices (removes .00)
    setTimeout(stripTrailingZerosFromPrices, 200);

    // The cart footer should already be updated via getCart() -> build() -> priceHolder.innerHTML
    // But we can verify it updated by checking if the totals changed
    // The server-rendered HTML includes updated cart.original_total_price and cart.total_price
  });

  // Function to update the footer progress bar span width
  function updateProgressBar() {
    const footerBar = document.querySelector('.cart-drawer__footer-shipping-bar');
    const footerMsg = document.querySelector('.cart-drawer__footer-shipping');
    const cartTotal = document.querySelector('[data-cart-total]');

    if (!footerBar || !footerMsg || !cartTotal) {
      return;
    }

    // Get limit from data-limit attribute
    const limit = footerMsg.getAttribute('data-limit');
    if (!limit) {
      return;
    }

    // Get current subtotal from the updated cart total element
    const subtotal = parseInt(cartTotal.getAttribute('data-cart-total')) || 0;
    if (subtotal === 0) {
      return;
    }

    // Calculate percentage
    let limitCents = parseFloat(limit) * 100;
    if (window.Shopify?.currency?.rate) {
      limitCents *= window.Shopify.currency.rate;
    }

    const percent = Math.min(Math.max((subtotal / limitCents) * 100, 0), 100);

    // Update the span width
    const span = footerBar.querySelector('span');
    if (span) {
      span.style.width = percent + '%';
    }

    // Update free shipping message visibility - only target elements that contain message spans
    const allCartMessages = document.querySelectorAll('[data-cart-message]');

    allCartMessages.forEach((message) => {
      // Check for message elements (different structures for different parts)
      const cartMessageDefault = message.querySelector('[data-message-default]');
      const cartMessageSuccess = message.querySelector('.cart-message__success') || message.querySelector('[data-message-success]');

      if (!cartMessageDefault || !cartMessageSuccess) {
        return;
      }

      const hasFreeShipping = message.hasAttribute('data-cart-message') && message.getAttribute('data-cart-message') === 'true' && subtotal !== 0;
      const shouldShowSuccess = subtotal >= limitCents && hasFreeShipping;

      message.classList.toggle('is-success', shouldShowSuccess);
      message.classList.toggle('is-hidden', subtotal === 0);
      if (cartMessageDefault) {
        cartMessageDefault.classList.toggle('is-hidden', subtotal >= limitCents);
      }
      if (cartMessageSuccess) {
        // Handle different visibility approaches
        if (cartMessageSuccess.hasAttribute('data-message-success')) {
          // Footer approach: toggle is-hidden directly on success message
          cartMessageSuccess.classList.toggle('is-hidden', !shouldShowSuccess);
        }
      }
    });

    // Remove loading state
    footerBar.classList.remove('is-loading');
    const shimmer = footerBar.querySelector('.progress-shimmer');
    if (shimmer) shimmer.remove();
  }

  // Function to update cart count badges in app header (not cart drawer)
  function updateCartCount() {
    // Get current cart count from the cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemCount = cart.item_count || 0;

        // Update all cart count badges in the app header (not cart drawer)
        const countElements = document.querySelectorAll('[data-cart-items-qty]');
        countElements.forEach(element => {
          // Skip cart drawer header elements (they update via theme)
          if (!element.closest('.cart-drawer__header')) {
            element.textContent = itemCount;
            // Hide badge if count is 0
            element.style.display = itemCount > 0 ? '' : 'none';
          }
        });
      })
      .catch(err => console.error('Error updating cart count:', err));
  }

  // Hook into theme's updateProgress() to update footer progress bar span width
  // This runs after build() completes and updates the progress bar
  (function() {
    function hookUpdateProgress() {
      if (window.theme && window.theme.cart && typeof window.theme.cart.updateProgress === 'function') {
        const original = window.theme.cart.updateProgress;
        window.theme.cart.updateProgress = function() {
          original.apply(this, arguments);

          // Update footer progress bar span width
          setTimeout(function() {
            const footerBar = document.querySelector('.cart-drawer__footer-shipping-bar');
            const footerMsg = document.querySelector('.cart-drawer__footer-shipping');

            if (footerBar && footerMsg && window.theme.cart.subtotal) {
              const limit = footerMsg.getAttribute('data-limit');
              if (limit) {
                let limitCents = parseFloat(limit) * 100;
                if (window.Shopify?.currency?.rate) {
                  limitCents *= window.Shopify.currency.rate;
                }

                const percent = Math.min((window.theme.cart.subtotal / limitCents) * 100, 100);
                const span = footerBar.querySelector('span');
                if (span) {
                  span.style.width = percent + '%';
                }

                // Remove loading state
                footerBar.classList.remove('is-loading');
                const shimmer = footerBar.querySelector('.progress-shimmer');
                if (shimmer) shimmer.remove();
              }
            }
          }, 10);
        };
      } else {
        setTimeout(hookUpdateProgress, 100);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hookUpdateProgress);
    } else {
      hookUpdateProgress();
    }
  })();


  document.addEventListener('shopify:section:load', function() {
    setTimeout(stripTrailingZerosFromPrices, 100);
  });

  // Move product features row on mobile
  function moveFeaturesRowOnMobile() {
    if (window.innerWidth > 767) return;

    const galleryCustomContent = document.querySelector('.product-gallery__wrapper .product-gallery__custom-content');
    const formWrapper = document.querySelector('.product-single__details .form__wrapper');
    const formBlock = document.querySelector('.product-single__details .product__block.product__form__wrapper');

    if (galleryCustomContent && formWrapper && formBlock && !galleryCustomContent.dataset.moved) {
      galleryCustomContent.dataset.moved = 'true';
      if (formBlock.nextSibling) {
        formWrapper.insertBefore(galleryCustomContent, formBlock.nextSibling);
      } else {
        formWrapper.appendChild(galleryCustomContent);
      }
    }
  }

  function restoreFeaturesRowOnDesktop() {
    if (window.innerWidth <= 767) return;

    const galleryCustomContent = document.querySelector('.product-gallery__custom-content[data-moved="true"]');
    const galleryWrapper = document.querySelector('.product-gallery__wrapper');

    if (galleryCustomContent && galleryWrapper && !galleryWrapper.querySelector('.product-gallery__custom-content')) {
      delete galleryCustomContent.dataset.moved;
      galleryWrapper.appendChild(galleryCustomContent);
    }
  }

  function handleResize() {
    restoreFeaturesRowOnDesktop();
    moveFeaturesRowOnMobile();
  }

  function initFeaturesRowMovement() {
    moveFeaturesRowOnMobile();
    window.addEventListener('resize', handleResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initFeaturesRowMovement, 100);
    });
  } else {
    setTimeout(initFeaturesRowMovement, 100);
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(moveFeaturesRowOnMobile, 100);
  });

  // ================ Prevent Cart Drawer Aside from closing cart ================
  function preventAsideClosingCart() {
    const aside = document.querySelector('.cart-drawer__aside');
    if (aside) {
      aside.addEventListener('mousedown', function(e) {
        e.stopPropagation();
      });
      aside.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preventAsideClosingCart);
  } else {
    preventAsideClosingCart();
  }

  // ================ Selling Plans Dropdown (Event Delegation) ================
  // Use event delegation for better handling of dynamically added content

  // Lock to prevent multiple simultaneous updates
  let isUpdatingSellingPlan = false;

  document.addEventListener('click', function(e) {
    // Don't toggle if clicking inside the options or on a label/radio
    if (e.target.closest('[data-selling-plans-options]') ||
        e.target.closest('.cart__item__selling-plan-option') ||
        e.target.closest('[data-selling-plan-radio]')) {
      return;
    }

    // Prevent toggle if update is in progress
    if (isUpdatingSellingPlan) {
      return;
    }

    // Toggle dropdown
    const toggle = e.target.closest('[data-selling-plans-toggle]');
    if (toggle) {
      // Check if the cart item is currently being updated
      const cartItem = toggle.closest('[data-cart-item]');
      if (cartItem && (cartItem.classList.contains('is-removed') || cartItem.classList.contains('is-loading'))) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      const wrapper = toggle.closest('[data-selling-plans-wrapper]');
      if (wrapper) {
        const isOpen = wrapper.classList.contains('is-open');
        wrapper.classList.toggle('is-open');
      }
    }
  });

  document.addEventListener('change', function(e) {
    // Handle radio button changes
    const radio = e.target.closest('[data-selling-plan-radio]');
    if (radio) {
      // Prevent multiple simultaneous updates - check lock early
      if (isUpdatingSellingPlan) {
        // Revert the radio selection
        e.preventDefault();
        return;
      }
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Get the cart item element - this will have the current line key
      const cartItem = radio.closest('[data-cart-item]');
      if (!cartItem) {
        console.error('Could not find cart item element');
        return;
      }

      // Check if this cart item is already being updated (has loading state)
      if (cartItem.classList.contains('is-removed') || cartItem.classList.contains('is-loading')) {
        // Revert the radio selection
        const currentChecked = cartItem.querySelector('[data-selling-plan-radio]:checked');
        if (currentChecked) {
          radio.checked = false;
          currentChecked.checked = true;
        }
        return;
      }

      // Get the current line key from the cart item's data-item attribute
      const lineKey = cartItem.getAttribute('data-item');
      const variantId = radio.dataset.variantId;
      const sellingPlanId = radio.value;

      if (!lineKey) {
        console.error('Could not find line key from cart item');
        return;
      }


      // Store the original checked radio value for error recovery
      const wrapper = radio.closest('[data-selling-plans-wrapper]');
      let originalCheckedValue = '';
      if (wrapper) {
        const originalChecked = wrapper.querySelector('[data-selling-plan-radio]:checked');
        if (originalChecked) {
          originalCheckedValue = originalChecked.value;
        }

        // Update the label text
        const label = wrapper.querySelector('.cart__item__selling-plans-label');
        if (label) {
          if (sellingPlanId) {
            label.textContent = 'SUBSCRIBE & SAVE';
          } else {
            label.textContent = 'ONE-TIME PURCHASE';
          }
        }
        // Keep dropdown open after selection
      }

      // Make API call to update the cart item
      updateCartItemSellingPlan(lineKey, variantId, sellingPlanId, cartItem, originalCheckedValue);
    }
  });

  // Also prevent label clicks from bubbling
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cart__item__selling-plan-option') && !e.target.closest('[data-selling-plans-toggle]')) {
      e.stopPropagation();
    }
  }, true); // Use capture phase to catch it early

  async function updateCartItemSellingPlan(lineKey, variantId, sellingPlanId, cartItem, originalCheckedValue = '') {
    // Prevent multiple simultaneous updates
    if (isUpdatingSellingPlan) {
      return;
    }

    isUpdatingSellingPlan = true;

    try {
      // Get current quantity before making changes
      const quantityField = cartItem ? cartItem.querySelector('[data-quantity-field]') : null;
      const quantity = quantityField ? parseInt(quantityField.value) || 1 : 1;

      // Show loading state to prevent layout shifts during update
      if (cartItem) {
        // Store the item's position and dimensions to maintain layout
        const itemRect = cartItem.getBoundingClientRect();
        const itemHeight = cartItem.offsetHeight;
        const itemWidth = cartItem.offsetWidth;

        // Add is-loading class and preserve dimensions
        cartItem.classList.add('is-loading');
        cartItem.style.minHeight = itemHeight + 'px';
        cartItem.style.width = itemWidth + 'px';
        cartItem.style.visibility = 'visible'; // Keep visible to prevent layout shift

        // Create loading overlay with skeleton if it doesn't exist
        let loadingOverlay = cartItem.querySelector('.cart__item__loading-overlay');
        if (!loadingOverlay) {
          loadingOverlay = document.createElement('div');
          loadingOverlay.className = 'cart__item__loading-overlay';
          loadingOverlay.innerHTML = '<div class="cart__item__skeleton"><div class="cart__item__skeleton-shimmer"></div></div>';
          cartItem.style.position = 'relative';
          cartItem.appendChild(loadingOverlay);
        }
        loadingOverlay.style.display = 'block';
      }

      // Add loading state to progress bar for selling plan changes
      const footerBar = document.querySelector('.cart-drawer__footer-shipping-bar');
      if (footerBar) {
        footerBar.classList.add('is-loading');
        const span = footerBar.querySelector('span');
        if (span && !span.querySelector('.progress-shimmer')) {
          const shimmer = document.createElement('div');
          shimmer.className = 'progress-shimmer';
          span.appendChild(shimmer);
        }
      }

      // Disable cart buttons and add loading class if theme methods are available
      if (window.theme && window.theme.cart) {
        if (typeof window.theme.cart.disableCartButtons === 'function') {
          window.theme.cart.disableCartButtons();
        }
        if (typeof window.theme.cart.addLoadingClass === 'function') {
          window.theme.cart.addLoadingClass();
        }
      }

      // Step 1: Remove the old item

      // Verify the line key still exists in the current cart
      const currentCartResponse = await fetch('/cart.js');
      const currentCart = await currentCartResponse.json();
      const lineItemExists = currentCart.items && currentCart.items.some(item => item.key === lineKey);

      if (!lineItemExists) {
        // Still proceed to add step in case item was already removed
      } else {
        const removeResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lineKey,
            quantity: 0
          })
        });

        if (!removeResponse.ok) {
          const errorText = await removeResponse.text();
          console.error('Failed to remove item:', errorText);
          throw new Error('Failed to remove item from cart: ' + errorText);
        }

        const removeData = await removeResponse.json();

        // Don't refresh cart UI yet - we'll do it once at the end
        // Just wait a moment for Shopify to process the removal
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      // Step 2: Add new item with the selling plan (or without)
      const addData = {
        id: parseInt(variantId),
        quantity: quantity
      };

      if (sellingPlanId) {
        addData.selling_plan = parseInt(sellingPlanId);
      }

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [addData] })
      });

      if (!addResponse.ok) {
        const errorText = await addResponse.text();
        console.error('Failed to add item:', errorText);
        throw new Error('Failed to add item to cart: ' + errorText);
      }

      const addDataResult = await addResponse.json();
      const itemCount = addDataResult.item_count || (addDataResult.items && addDataResult.items.length) || 0;

      // Wait a moment for Shopify to recalculate cart totals (important for selling plan discounts)
      await new Promise(resolve => setTimeout(resolve, 100));

      // Verify cart totals are updated by fetching cart.js first
      const verifyCartResponse = await fetch('/cart.js');
      const verifyCart = await verifyCartResponse.json();

      // Now refresh the cart UI once at the end (this updates everything including footer)
      // This is the only UI update, so footer only updates once
      await new Promise((resolve) => {
        let resolved = false;
        const onCartLoaded = function() {
          if (resolved) return;
          resolved = true;


          // Wait a moment for DOM to settle before removing loading state
          setTimeout(() => {
            document.removeEventListener('theme:cart:loaded', onCartLoaded);
            document.removeEventListener('theme:cart:refresh', onCartLoaded);
            resolve();
          }, 200);
        };
        document.addEventListener('theme:cart:loaded', onCartLoaded);
        document.addEventListener('theme:cart:refresh', onCartLoaded);

        // Trigger final cart refresh (only once)
        if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
          window.theme.cart.getCart();
        } else {
          // Fallback: dispatch event
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }

        // Fallback timeout
        setTimeout(() => {
          if (!resolved) {
            document.removeEventListener('theme:cart:loaded', onCartLoaded);
            document.removeEventListener('theme:cart:refresh', onCartLoaded);
            resolve();
          }
        }, 3000);
      });

      // Clean up loading state (note: cartItem may have been replaced during refresh)
      // The new cart item will appear without loading state since it's from fresh HTML
      // But we clean up just in case the element still exists
      if (cartItem && document.body.contains(cartItem)) {
        cartItem.classList.remove('is-loading');
        cartItem.style.minHeight = '';

        // Hide loading overlay
        const loadingOverlay = cartItem.querySelector('.cart__item__loading-overlay');
        if (loadingOverlay) {
          loadingOverlay.style.display = 'none';
        }
      }

      if (window.theme && window.theme.cart) {
        if (typeof window.theme.cart.enableCartButtons === 'function') {
          window.theme.cart.enableCartButtons();
        }
        if (typeof window.theme.cart.removeLoadingClass === 'function') {
          window.theme.cart.removeLoadingClass();
        }
      }

      // Release lock
      isUpdatingSellingPlan = false;

    } catch (error) {
      console.error('Error updating selling plan:', error);

      // Restore cart item state
      if (cartItem) {
        cartItem.classList.remove('is-loading');
        cartItem.style.minHeight = '';
        cartItem.style.opacity = '';
        cartItem.style.pointerEvents = '';

        // Hide loading overlay
        const loadingOverlay = cartItem.querySelector('.cart__item__loading-overlay');
        if (loadingOverlay) {
          loadingOverlay.style.display = 'none';
        }

        // Revert the radio button selection to original state
        const wrapper = cartItem.querySelector('[data-selling-plans-wrapper]');
        if (wrapper && originalCheckedValue !== undefined) {
          const radios = wrapper.querySelectorAll('[data-selling-plan-radio]');
          radios.forEach(function(radio) {
            radio.checked = (radio.value === originalCheckedValue);
          });

          // Revert the label text
          const label = wrapper.querySelector('.cart__item__selling-plans-label');
          if (label) {
            if (originalCheckedValue) {
              label.textContent = 'SUBSCRIBE & SAVE';
            } else {
              label.textContent = 'ONE-TIME PURCHASE';
            }
          }
        }
      }

      // Clean up loading state
      if (window.theme && window.theme.cart) {
        if (typeof window.theme.cart.enableCartButtons === 'function') {
          window.theme.cart.enableCartButtons();
        }
        if (typeof window.theme.cart.removeLoadingClass === 'function') {
          window.theme.cart.removeLoadingClass();
        }
      }

      // Try to refresh cart to get back in sync
      if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
        window.theme.cart.getCart();
      }

      // Release lock on error
      isUpdatingSellingPlan = false;
    }
  }

  // Function to refresh cart drawer content
  async function refreshCartDrawer() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();

      // Fetch the cart drawer HTML
      const drawerResponse = await fetch(window.location.href);
      const html = await drawerResponse.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update cart items holder
      const newItemsHolder = doc.querySelector('[data-cart-items-holder]');
      const currentItemsHolder = document.querySelector('[data-cart-items-holder]');
      if (newItemsHolder && currentItemsHolder) {
        currentItemsHolder.innerHTML = newItemsHolder.innerHTML;
      }

      // Update cart count
      const cartCountElements = document.querySelectorAll('[data-cart-items-qty]');
      cartCountElements.forEach(function(el) {
        el.textContent = cart.item_count;
      });

      // Update totals
      const cartTotalElements = document.querySelectorAll('[data-cart-total]');
      cartTotalElements.forEach(function(el) {
        el.setAttribute('data-cart-total', cart.total_price);
      });

    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
      // Fallback to page reload
      window.location.reload();
    }
  }





  // Listen for theme cart events to update progress bar live
  // Add loading state when cart updates start
  document.addEventListener('theme:cart:update', function() {
    const footerBar = document.querySelector('.cart-drawer__footer-shipping-bar');
    if (footerBar) {
      footerBar.classList.add('is-loading');
      const span = footerBar.querySelector('span');
      if (span && !span.querySelector('.progress-shimmer')) {
        const shimmer = document.createElement('div');
        shimmer.className = 'progress-shimmer';
        span.appendChild(shimmer);
      }
    }
  });

  // Update progress bar and cart count when cart changes complete
  document.addEventListener('theme:cart:added', function() {
    updateProgressBar();
    updateCartCount();
  });

  // Also add loading state for remove button clicks
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-item-remove]')) {
      const footerBar = document.querySelector('.cart-drawer__footer-shipping-bar');
      if (footerBar) {
        footerBar.classList.add('is-loading');
        const span = footerBar.querySelector('span');
        if (span && !span.querySelector('.progress-shimmer')) {
          const shimmer = document.createElement('div');
          shimmer.className = 'progress-shimmer';
          span.appendChild(shimmer);
        }
      }
    }
  }, true);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
